import React from "react";
import { Route, Routes } from "react-router-dom";
import LeasecontrolPage from "../pages/LeasecontrolMainPage";
import LeasecontrolUsuariosPage from "../pages/LeasecontrolUsuariosPage";
import LeasecontrolUnidadesPage from "../pages/LeasecontrolUnidadesPage";
import LeasecontrolGruposPage from "../pages/LeasecontrolGruposPage";

const LeasecontrolRoutes = () => {
  return (
    <Routes>
      <Route index element={<LeasecontrolPage />} />
      <Route path="usuarios" element={<LeasecontrolUsuariosPage />} />
      <Route path="vehiculos" element={<LeasecontrolUnidadesPage />} />
      <Route path="grupos" element={<LeasecontrolGruposPage />} />
      <Route path="*" element={<LeasecontrolPage />} />
    </Routes>
  );
};

export default LeasecontrolRoutes;
